/**
 * User Service
 */

DM.Service.User = (function () {
    var URL_ENDPOINT = '/shared/getUser';

    return {
        getUser: function(data) {
            return fetch(URL_ENDPOINT, data).then(response => response.json());
        }
    };
})();
